import { createAction, props } from '@ngrx/store';
import { AssociationLabelDto } from '@shared/models/association-label-dto';

export const associationLabelGet = createAction(
  '[Association Label] Get Label',
  props<{ jobId: number; candidateId: number }>(),
);

export const associationLabelGetSuccess = createAction(
  '[Association Label] Get Labels Success',
  props<{ entities: AssociationLabelDto[] }>(),
);

export const associationLabelGetFailure = createAction(
  '[Association Label] Get Label Failure',
  props<{ error: any }>(),
);
